import { Ortak } from './../../../providers/ortak';
import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { Component } from '@angular/core';
import {  NavController, NavParams } from 'ionic-angular';
import { ViewController } from 'ionic-angular/navigation/view-controller';
import { elementDef } from '@angular/core/src/view/element';

/**
 * Generated class for the CarieklePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-cariekle',
  templateUrl: 'cariekle.html',
})
export class CarieklePage {
  cari: any = { ID: -1, Definition_: "",GrupRef:1 };
  vwCari: any = {};
  GrupListesi = [];
  aranan = "";
  skip: number = 0;
  take: number = 50;
  constructor(public navCtrl: NavController,
     public ortak: Ortak,
      public bllOrtak: BllOrtak,
       public viewCtrl: ViewController,
        public navParams: NavParams) {
    if (navParams.get("vwCari") != null) {
      this.vwCari = navParams.get("vwCari");
      var data = new FormData();
      data.append("cari_id", this.vwCari.ID);
      this.bllOrtak.islem(data, "CariGetirByID", "", false).then(a => {
        var Sonuc = <any>a;
        this.cari = Sonuc.SonucObject;
      }
      )
    }
  }

  ionViewDidLoad() {
    this.GrupGetir();
  }
  kapat() {
    this.viewCtrl.dismiss();
  }
  boslukKontrol() {
    var mesaj = "";
    if (this.cari.Definition_ == null || this.cari.Definition_ == "") {
      mesaj = mesaj + "Lütfen cari adını giriniz. <br/>";
    }

    if (mesaj == "") {
      return true;
    }
    else {
      this.ortak.showBasicAlert("Uyarı", mesaj);
      return false;
    }
  }
  kaydet() {

    var formData = new FormData();
  
    if (this.boslukKontrol()) {
      formData.append("cari_json", JSON.stringify(this.cari));
  
      this.bllOrtak.islem(formData, "CariEkleGuncelle", "", false).then(a => {
        var sonuc = <any>a;
       
        if (sonuc.Sonuc == 1) this.ortak.showBasicAlert("Başarılı", "İşlem Başarılı");
        if(sonuc.Sonuc==0)this.ortak.showBasicAlert("Hata",this.cari.Definition_+"  "+"bu müşteri adı ve cep telefonu zaten kayıtlı");
     

      })
      this.viewCtrl.dismiss();
    }


  }
 
    GrupGetir() {
      var formData = new FormData();
      formData.append("aranan", this.aranan);
      formData.append("skip", this.skip.toString());
      formData.append("take", this.take.toString());
      this.bllOrtak.islem(formData, "CariGrupListesi", "", false).then(a => {
     
        var sonuc = <any>a;
        this.GrupListesi = sonuc.SonucObject;
      
      })
    }
    

  }








// WEBPACK FOOTER //
// ./src/pages/CariIslemleri/cariekle/cariekle.ts